import Spinner from '~/components/Spinner';
import { Stack, Typography } from '@customink/pigment-react';
import { useLayoutEffect } from 'react';
import { signalmizelyLink } from '~/adapters/services/rfe/links';

export function LoadingSignalmizely() {
    useLayoutEffect(() => {
        window.location.href = signalmizelyLink();
    }, []);

    return (
        <Stack mt={5} sx={{ flexDirection: 'row', alignItems: 'center' }} gap={2}>
            <Spinner size={40} />
            <Typography variant="headingLarge">Redirecting to signalmizely...</Typography>
        </Stack>
    );
}
